import { memo } from 'react';
import { SicBoRoadmapRecord } from '../../../../models/games/sicbo';
import { useSicBoRoadMapCellColorText } from '../hook';

const SicBoPointRoadCell = ({
    size,
    BigSmallResult,
    PointResult,
}: {
    size: number;
    BigSmallResult: SicBoRoadmapRecord['BigSmallResult'];
    PointResult: number;
}) => {
    const { color } = useSicBoRoadMapCellColorText(BigSmallResult);
    return (
        <>
            <svg width={size} height={size}>
                {BigSmallResult !== '' && (
                    <>
                        <rect
                            width={size}
                            height={size}
                            style={{
                                fill: color,
                            }}
                        />
                        <text
                            x={size / 2}
                            y={size / 2}
                            textAnchor="middle"
                            dominantBaseline="middle"
                            fill="#ffffff"
                            fontSize={size * 0.6}
                            fontWeight={'bold'}
                        >
                            {PointResult}
                        </text>
                    </>
                )}
            </svg>
        </>
    );
};

export default memo(SicBoPointRoadCell);
